import { create } from "zustand"
import { userHasPageAccess } from "../utils/globalHelper"
import { RoleId } from "../utils/constants"
import UsersService from "../API/UsersService"

export const useGlobalStore = create((set, get) => ({
    user: null,
    setUser: (newUser) => {
        set({ user: newUser })
        get().setPageAccess(newUser)
    },

    pageAccess: {},
    setPageAccess: (user) => {
        if (user) {
            set({ pageAccess: {
                /* раздел "Администратор" */
                adminSettings: userHasPageAccess(user, []),

                /* раздел "Мои ученики" */
                myStudents: userHasPageAccess(user, [
                    RoleId.LK9, RoleId.LK11, RoleId.SK9, RoleId.SK11, RoleId.PM, RoleId.CURATOR9, RoleId.CURATOR11
                ]),
                myStudentsMyStudents: userHasPageAccess(user, [
                    RoleId.LK9, RoleId.LK11, RoleId.SK9, RoleId.SK11, RoleId.PM
                ]),
                myStudentsProlongations: userHasPageAccess(user, [
                    RoleId.SK9, RoleId.SK11, RoleId.PM
                ]),
                myStudentsAddsales: userHasPageAccess(user, [
                    RoleId.LK9, RoleId.LK11, RoleId.SK9, RoleId.SK11, RoleId.PM
                ]),
                myStudentsTests: userHasPageAccess(user, [
                    RoleId.LK9, RoleId.LK11, RoleId.SK9, RoleId.SK11, RoleId.CURATOR9, RoleId.CURATOR11
                ]),

                /* раздел "Дежурства" */
                duty: userHasPageAccess(user, [
                    RoleId.LK9, RoleId.LK11, RoleId.SK9, RoleId.SK11, RoleId.CURATOR9, RoleId.CURATOR11
                ]),

                /* раздел "Мои исполнители" */ 
                myEmployees: userHasPageAccess(user, [
                    RoleId.RP, RoleId.ROK, RoleId.ROK_dep, RoleId.ROPM, RoleId.ROPM_dep, RoleId.RG,
                    RoleId.NK9, RoleId.NK11, RoleId.NPM, RoleId.SNK9, RoleId.SNK11,
                ]),

                /* раздел "Аналитика" */
                analytics: userHasPageAccess(user, [RoleId.ANALYST]),

                /* раздел "Сбор баллов" */
                collectionScores: userHasPageAccess(user, [RoleId.SK9, RoleId.SK11, RoleId.PM]),
                CollectingStatistics: userHasPageAccess(user, []),
            }})
        }
    },

    subjects: [],
    setSubject: (subjects) => set({ subjects: subjects }),

    contexts: [],
    fetchContexts: async () => {
        if (get().contexts.length < 1) {
            const response = await UsersService.getContexts()
            if (response?.status === 200) {
                set({ contexts: response.data })
                set({ subjects: response?.data?.length > 0 ? response.data[0]?.subjects : [] })
            }
        }
    },
}))
